import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { InfoBlock, InfoBlockTypes } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import styles from './SavedMessagesEmpty.styles.m.css';

export const SavedMessagesEmpty: FC = () => {
  const { t } = useTranslation();

  return (
    <InfoBlock
      className={styles.infoBlock}
      iconClassName={styles.icon}
      type={InfoBlockTypes.Chat}
      image={getMascotImageSrc(PROJECT_CONFIG.imageAssets.savedMessages)}
    >
      <h3 className={styles.title}>{t('saved_messages_description_title')}</h3>

      <ul className={styles.list}>
        <li className={styles.listItem}>
          <div className={styles.bullet} />
          {t('saved_messages_description_third')}
        </li>
        <li className={styles.listItem}>
          <div className={styles.bullet} />
          {t('saved_messages_description_one')}
        </li>
        <li className={styles.listItem}>
          <div className={styles.bullet} />
          {t('saved_messages_description_second')}
        </li>
      </ul>
    </InfoBlock>
  );
};
